export const useClsUtil_02 = () => {
  const getCls01 = () => {
    const baseClasses = ["rounded-10 backdrop-blur-10 flex flex-col"];
    baseClasses.push("gap-y-16", "p-16");

    baseClasses.push("bg-[var(--app-bg-08)]");

    return baseClasses;
  };
  const getCls02 = () => {
    const baseClasses = ["text-ellipsis-2"];
    baseClasses.push("color-[var(--app-text-14)]", "font-weight-500", "text-13");
    return baseClasses;
  };
  const getCls03 = () => {
    const baseClasses = ["block"];

    return baseClasses;
  };
  const getCls04 = () => {};
  return { getCls01, getCls02, getCls03, getCls04 };
};
